import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
};

const adminSlice = createSlice({
  name: "Admin",
  initialState: {
    isLoading: false,

    suplier: {},
    adminList: [],
  },
  reducers: {
    // login
    getAdminsRequest: (state) => setLoading(state, true),
    getAdminsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "adminList"),
    getAdminsFailure: (state) => setLoading(state, false),

    //assign Budget
        assignBudgetRequest: (state) => setLoading(state, true),
        assignBudgetSuccess: (state) => setLoading(state, false),
        assignBudgetFailure: (state) => setLoading(state, false),
  },
});

export const { getAdminsRequest, getAdminsSuccess, getAdminsFailure,
  assignBudgetRequest, assignBudgetSuccess, assignBudgetFailure
 } =
  adminSlice.actions;

export const adminReducerSlice = adminSlice.reducer;
